export default "/images/vendor/flag-icons/flags/1x1/tn.svg?4e7d8d8c98cc74fc52a9c3155c96d3b1";